module.exports = __webpack_public_path__ + "static/media/PRACTICA4.f8bf1e2a.jpg";